import { getStore } from '~/mobx/AppStore';
import { showMessageModal } from '~/clientUtils/showMessageModal';

const getZipcodeListAndPagination = async () => {
    const { zipcodeStore } = getStore();
    zipcodeStore.setIsGettingZipcode(true);
    try {
        await zipcodeStore.getZipcode();
        zipcodeStore.getPaginationData();
        zipcodeStore.getZipcodeList();
    } catch (error) {
        showMessageModal('error', 'Error getting zipcode');
    } finally {
        zipcodeStore.setIsGettingZipcode(false);
    }
};
export default getZipcodeListAndPagination;
